import * as React from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Box, Tooltip } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

interface BreadcrumbsProps {
  originGuid: string | undefined
  originNumber: string | undefined
  originName: string | undefined
  collectionGuid: string | undefined
  collectionNumber: string | undefined
  collectionName: string | undefined
  isItem?: boolean | undefined
}

export function BasicBreadcrumbs({
  originGuid,
  originNumber,
  originName,
  collectionGuid,
  collectionNumber,
  collectionName,
  isItem,
}: BreadcrumbsProps) {
  return (
    <Box mb={1}>
      <Breadcrumbs
        aria-label='breadcrumb'
        separator={<NavigateNextIcon fontSize='small' />}
      >
        <Tooltip
          title={`Uppruni ${originNumber} ${originName ?? ''}`.trim()}
          arrow
        >
          <Link
            variant='subtitle2'
            underline='hover'
            color='primary'
            href={`/uppruni/${originGuid}`}
            sx={{
              display: 'inline-block',
              maxWidth: '280px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            Uppruni {originNumber} {originName}
          </Link>
        </Tooltip>
        {isItem && (
          <Tooltip title={`Aðfang ${collectionNumber} ${collectionName}`} arrow>
            <Link
              variant='subtitle2'
              underline='hover'
              color='primary'
              href={`/adfang/${collectionGuid}`}
              sx={{
                display: 'inline-block',
                maxWidth: '280px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              Aðfang {collectionNumber} {collectionName}
            </Link>
          </Tooltip>
        )}
        <Link href='#'> </Link>
      </Breadcrumbs>
    </Box>
  )
}
